import { useMutation } from '@tanstack/react-query'
import { emailServiceApi } from '../api/emailServiceApi'
import type { NotifyAdminRequest } from '../api/emailServiceApi'
import { toast } from '@/integrations/toaster-provider'

export default function useNotifyAdminMutation(onNotifyComplete: () => void) {
  return useMutation({
    mutationFn: (data: NotifyAdminRequest) => emailServiceApi.notifyAdmin(data),
    onSuccess: () => {
      toast.success(
        'Super admin has been notified about the email service issue',
      )
      onNotifyComplete()
    },
    onError: (mutationError: Error) => {
      toast.error(`Failed to notify admin: ${mutationError.message}`)
      onNotifyComplete()
    },
  })
}
